<template>
  <div class="app-container">
    <!-- <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="分类名称：">
            <el-input v-model="query.name" placeholder="请输入分类名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.isEnable" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card> -->
    <el-card class="box-card">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新增地址</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" row-key="id" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="编码" prop="regionCode" align="center" />
        <el-table-column label="名称" prop="regionName" align="center" />
        <el-table-column label="地址分类" prop="regionType" align="center" >
          <template slot-scope="{row}">
            {{row.regionType === 1?'省':(row.regionType === 2?'市':(row.regionType === 3?'区':'国家级别'))}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="页面排序 " prop="sort" align="center" /> -->
        <el-table-column label="操作" align="center" width="230">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)" >编辑</el-button>
            <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <classify-add ref="classifyAdd" @created="doQueryList({})" :menuOptions="list" />
  </div>
</template>

<script>
import classifyAdd from './add'
import sysAddrApi from '@/api/system/sysAddr'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
    classifyAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return sysAddrApi.fetchTreeList2()
        .then(({data}) => {
          this.list = data
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => sysAddrApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择分类')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => sysAddrApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.classifyAdd.handleCreate()
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.classifyShow.handleShow(row.id)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.classifyAdd.handleUpdate(row)
    }
  }
}
</script>
